import React from 'react'
import { Field } from 'redux-form'
import {
    Edit,
    ReferenceInput,
    TextInput,
    SelectInput,
    SelectArrayInput
} from 'react-admin'

import {ReferenceSelectInput} from '../Inputs'
import { CustomSimpleForm } from '../Generic'

export const PermisoEdit = props => (
    <Edit {...props}>
        <CustomSimpleForm>
            <TextInput source="id" disabled/>
            <ReferenceInput label="Usuario" source="user" reference="usuarios" disabled>
                <SelectInput optionText="username" />
            </ReferenceInput>
            <Field
                name={"empresa"}
                label={"Empresa"}
                required={true}
                component={ReferenceSelectInput}
                reference={"empresas"}
                isDisabled
            />
            <SelectArrayInput label="Permisos" source="permissions" choices={[
                { id: 'read', name: 'Ver' },
                { id: 'edit', name: 'Editar' },
                // { id: 'admin_users', name: 'Administrar Usuarios' }
            ]} />
        </CustomSimpleForm>
    </Edit>
);
